import { render, staticRenderFns } from "./FilterListItem.vue?vue&type=template&id=2b54bb72&scoped=true&"
import script from "./FilterListItem.vue?vue&type=script&lang=js&"
export * from "./FilterListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54bb72",
  null
  
)

export default component.exports